var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "nudge-right": 40,
        transition: "scale-transition",
        "offset-y": "",
        "min-width": "auto",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-text-field",
                _vm._g(
                  _vm._b(
                    {
                      attrs: { "prepend-icon": "mdi-calendar", readonly: "" },
                      model: {
                        value: _vm.dateRangeText,
                        callback: function ($$v) {
                          _vm.dateRangeText = $$v
                        },
                        expression: "dateRangeText",
                      },
                    },
                    "v-text-field",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showDateSelector,
        callback: function ($$v) {
          _vm.showDateSelector = $$v
        },
        expression: "showDateSelector",
      },
    },
    [
      _c("v-date-picker", {
        attrs: { color: "light-blue accent-2", range: "", "no-title": "" },
        on: { change: _vm.onRangeSelected },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }